<script setup lang="ts">
  import { Icon, Typo } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { POINT_ICONS } from '../lib';
  import { type Point, PointType, Direction } from '../Transfer.types';

  interface DirectionPointsProps {
    points: Point[];
    direction: `${Direction}`;
  }

  const props = defineProps<DirectionPointsProps>();

  const computedPoints = computed(() => {
    const airportTitle = props.points.find((point) => point.type === PointType.Airport)?.title || '';
    const hotelTitle = props.points.find((point) => point.type === PointType.Hotel)?.title || '';
    const points = [
      {
        icon: POINT_ICONS[PointType.Airport],
        title: airportTitle,
      },
      {
        icon: POINT_ICONS[PointType.Hotel],
        title: hotelTitle,
      },
    ];

    return props.direction === Direction.There ? points : points.reverse();
  });
</script>

<template>
  <div v-if="points.length > 0" class="tl-transfer-points">
    <div v-for="(point, index) in computedPoints" :key="index" class="tl-transfer-points__item">
      <Icon :name="point.icon" size="m" class="tl-transfer-points__icon" />
      <Typo variant="body-xl-400">{{ point.title }}</Typo>

      <Icon v-if="index === 0" name="chevron-right" size="xs" class="tl-transfer-points__icon" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tl-transfer-points {
    align-items: center;
    display: flex;
    gap: var(--spacing-xxs);

    &__item {
      align-items: center;
      display: flex;
      fill: var(--color-text-secondary);
      gap: var(--spacing-xxs);
    }

    &__icon {
      flex-shrink: 0;
    }
  }
</style>
